<script setup lang="ts">
  import { ref, type Ref } from 'vue';

  const prev = ref() as Ref<{ htmlElement: HTMLElement }>;
  const next = ref() as Ref<{ htmlElement: HTMLElement }>;

  defineExpose({ prev, next });
</script>
<template>
  <SfButton rounded square ref="prev" class="items-carousel__button items-carousel__button--prev" :aria-label="$t('SHOP.CAROUSEL.ACTION.PREVIOUS')">
    <SfIconChevronLeft aria-hidden="true" />
  </SfButton>
  <SfButton rounded square ref="next" class="items-carousel__button items-carousel__button--next" :aria-label="$t('SHOP.CAROUSEL.ACTION.NEXT')">
    <SfIconChevronRight aria-hidden="true" />
  </SfButton>
</template>
